import { writable, get } from "svelte/store";

const doLoading = writable(false);
const doBaseListLoading = writable(false);
const doBaseDataLoading = writable(false);
const doDialogLoading = writable(false);
const doDialogListLoading = writable(false);

const linksStore = writable({});

function setLinks(links) {
    let data;
    linksStore.update((value) => {
        data = links ? { ...value, ...links } : value;
        return data;
    });
    return data;
}

function getLinks(identfier) {
    const storeData = get(linksStore);
    if (!identfier) {
        return storeData;
    }
    return storeData[identfier];
}

export { getLinks, setLinks, doLoading, doBaseListLoading, doBaseDataLoading, doDialogLoading, doDialogListLoading };
